module.exports = __webpack_public_path__ + "img/standard_sx.f15705ee.png";